// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__2o9nJ","spinner":"Spinner_spinner___zFpu","content":"Spinner_content__34NqM","rowFlex":"Spinner_rowFlex__2UdYW"};